import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActionSheetController } from '@ionic/angular';
import * as $ from 'jquery'
import * as firestore from 'firebase'
import swal from 'sweetalert';
@Component({
  selector: 'app-vista-ruteros',
  templateUrl: './vista-ruteros.component.html',
  styleUrls: ['./vista-ruteros.component.scss'],
})
export class VistaRuterosComponent implements OnInit {
 ruteros=[]
  opening: any;
  constructor(private db:AngularFirestore,
    private auth:AngularFireAuth,
    public actionSheetController: ActionSheetController) { 
    this.traerRuteros()

  }

  ngOnInit() {
  }

  traerRuteros(){
    this.ruteros=[]
  this.auth.auth.onAuthStateChanged(j=>{

  this.db.collection('usuarios',ref=>ref.where('proveedor','==',j.uid)).get().subscribe(l=>{
    l.forEach(m=>{
       this.ruteros.push(m.data())
    })
  })
  })  
}

collapsed(id){
  var idOpen=id
  var ids='#'+id
    
  this.opening=id
  $('#'+id).slideToggle()


}

timing(time){
  let ti= new Date(time)
  return ti.getDate()
}

async presentActionSheet(i) {
  const actionSheet = await this.actionSheetController.create({
    header: 'Acciones',
    buttons: [
      
      {
        text: 'Eliminar',
        icon: 'trash-outline',
        role: 'destructive',
        handler: () => {
          this.eliminarRutero(i)
          console.log(i)
          console.log('Eliminar clicked');
          // Agrega aquí la lógica para eliminar
        },
      },
      {
        text: 'Cancelar',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancelar clicked');
        },
      },
    ],
  });

  await actionSheet.present();
}

eliminarRutero(i){
  this.db.collection("usuarios").doc(i).get().subscribe(w=>{
    var document=w.data()['documento']
    console.log(document)
    this.elimarDocumento(document)
    w.ref.delete().then(()=>{
      swal("Rutero Eliminado","rutero eliminado","success")
      this.traerRuteros()
    })
  })

}
elimarDocumento(doc){
  this.auth.auth.onAuthStateChanged(k=>{
    this.db.collection('usuarios').doc(k.uid).update({
      rutero:firestore.firestore.FieldValue.arrayRemove(doc)
    })
  })
 

}

}
